module.exports = __webpack_public_path__ + "img/database-02.ce99ca36.svg";